import React from "react"
import classes from "./CheckboxFilterItemRecursive.module.css"
import classnames from "classnames"
import { CheckboxFilterOption } from "../types"
import CustomButton from "../../../../../ui/atoms/Button"
import CustomCheckbox from "../../../../../ui/atoms/Checkbox"
import Typography from "../../../../../ui/atoms/Typography"

interface Props {
  options: CheckboxFilterOption[]
  firstLevel: boolean
  onClick: (option: CheckboxFilterOption) => void
  onExpand: (option: CheckboxFilterOption) => void
  expandedMap: any
  expanded?: boolean
}

const CheckboxFilterItemRecursive = ({
  options,
  onClick,
  firstLevel,
  expandedMap,
  onExpand,
  expanded,
}: Props) => {
  const isDisabled = (option: CheckboxFilterOption) => option.occurrences === 0
  const isExpanded = (option: CheckboxFilterOption) =>
    !isDisabled(option) && expandedMap[option.value]

  return (
    <ul
      className={classnames(
        "w-full",
        !firstLevel && "pl-9 sm:pl-4 mb-2",
        !expanded && "hidden"
      )}
    >
      {options.map((option) => {
        const label = `${option.label} (${option.occurrences})`
        if (option.children && option.children.length > 0) {
          return (
            <li key={option.value} className="flex flex-wrap items-center">
              <div
                className={classnames(
                  "cursor-pointer mr-2 text-xs",
                  classes.caret,
                  isExpanded(option) && classes["caret-down"]
                )}
                onClick={() => onExpand(option)}
              >
                &#9654;
              </div>
              <CustomButton
                variant="text"
                invariantCase
                noMinWidth
                className={classes.labelButton}
                onClick={() => onClick(option)}
                disabled={isDisabled(option)}
              >
                <Typography
                  variant="body1"
                  weightValue={400 as any}
                  className="truncate"
                >
                  {option.label} ({option.occurrences})
                </Typography>
              </CustomButton>
              <CheckboxFilterItemRecursive
                expandedMap={expandedMap}
                onExpand={onExpand}
                options={option.children}
                firstLevel={false}
                expanded={isExpanded(option)}
                onClick={onClick}
              />
            </li>
          )
        }
        return (
          <li key={option.value} className="flex items-center">
            <CustomCheckbox
              className={classes.checkbox}
              value={option.selected}
              customLabelClass={classes.checkboxLabel}
              onChange={() => onClick(option)}
              disabled={isDisabled(option)}
            />
            <CustomButton
              variant="text"
              invariantCase
              noMinWidth
              onClick={() => onClick(option)}
              disabled={isDisabled(option)}
            >
              <Typography
                variant="body1"
                weightValue={400 as any}
                className="truncate"
              >
                {label}
              </Typography>
            </CustomButton>
          </li>
        )
      })}
    </ul>
  )
}

export default CheckboxFilterItemRecursive
